import React from 'react'
import "./header.css"
import MyContext from '../../Context/AppContext'
import Dehaze from '@mui/icons-material/Dehaze';
import ManageAccounts from '@mui/icons-material/ManageAccounts';
import ExitToApp from '@mui/icons-material/ExitToApp';
import History from '@mui/icons-material/History';
import Email from '@mui/icons-material/Email';
import AdminPanelSettings from '@mui/icons-material/AdminPanelSettings';
import ExpandMore from '@mui/icons-material/ExpandMore';
import AccessTimeFilled from '@mui/icons-material/AccessTimeFilled';
import VerifiedUser from '@mui/icons-material/VerifiedUser';
import DoDisturbOn from '@mui/icons-material/DoDisturbOn';
import AppBar from '@mui/material/AppBar';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Toolbar from '@mui/material/Toolbar';
import { useNavigate } from 'react-router-dom'
import Userlogo from '../../assets/icons/userlogo';

function Header() {
    const { openDrawer, setOpenDrawer, setContactUsModalOpen, handleNavigationAllow, resetJobDescriptionStatus, userDetails, setUsageModal, setUserDetails } = React.useContext(MyContext);
    const [anchorElUser, setAnchorElUser] = React.useState(null);
    const [anchorElAdmin, setAnchorElAdmin] = React.useState(null);
    const navigate = useNavigate();

    const handleOpenUserMenu = (event) => {
        setAnchorElUser(event.currentTarget);
    };
    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    const handleOpenAdminMenu = (event) => {
        setAnchorElAdmin(event.currentTarget);
    };
    const handleCloseAdminMenu = () => {
        setAnchorElAdmin(null);
    };

    const goToAccountSettings = () => {
        let checkAllowedNavigation = handleNavigationAllow();
        if (checkAllowedNavigation) {
            setAnchorElUser(null);
            navigate('/app/settings');
        }
    }

    const goToUsers = (pagename) => {
        let checkAllowedNavigation = handleNavigationAllow();
        if (checkAllowedNavigation) {
            setAnchorElUser(null);
            setAnchorElAdmin(null);
            navigate(`/app/users/${pagename}`);
        }
    }

    const logOut = () => {
        localStorage.clear();
        resetJobDescriptionStatus();
        setUserDetails(null); // Clear user details state
        navigate('/');
    };

    const handleUsageHistory = () => {
        setAnchorElUser(null);
        setUsageModal({
            isOpen: true,
            userId: userDetails._id,
        });
    }

    return (
        <AppBar position="fixed" className='headerAppBar'>
            <Toolbar>
                {!openDrawer && (
                    <IconButton
                        size="large"
                        edge="start"
                        color="inherit"
                        aria-label="menu"
                        className='menuButton_Header'
                        onClick={() => setOpenDrawer(!openDrawer)}
                    >
                        <Dehaze />
                    </IconButton>
                )}
                <span className={openDrawer ? 'headerTitle titleAdjustment ' : 'headerTitle'}>
                    Noah.ai
                </span>

                <IconButton
                    size="large"
                    aria-label="account of current user"
                    aria-controls="menu-appbar"
                    aria-haspopup="true"
                    onClick={handleOpenUserMenu}
                    color="inherit"
                >
                    {/* <Avatar alt="Profile Picture" src={profileImage} /> */}
                    <Userlogo className="header_profile_logo" />
                </IconButton>

                <Menu
                    sx={{ mt: '45px' }}
                    id="menu-appbar"
                    anchorEl={anchorElUser}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    keepMounted
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    open={Boolean(anchorElUser)}
                    onClose={handleCloseUserMenu}
                >
                    <MenuItem className='menuHeaderItemsContainer' onClick={() => goToAccountSettings()}>
                        <ManageAccounts />
                        <span>Account Settings</span>
                    </MenuItem>
                    {userDetails?.accountConfig?.permissions?.checkUsage &&
                        <MenuItem className='menuHeaderItemsContainer' onClick={() => handleUsageHistory()}>
                            <History />
                            <span>Usage History</span>
                        </MenuItem>
                    }
                    {userDetails?.accountConfig?.permissions?.approveRequest &&
                        <MenuItem className='menuHeaderItemsContainer' onClick={handleOpenAdminMenu}>
                            <AdminPanelSettings />
                            <span>Admin</span>
                            <ExpandMore />
                        </MenuItem>
                    }
                    <MenuItem className='menuHeaderItemsContainer' onClick={() => setContactUsModalOpen(true)}>
                        <Email />
                        <span>Contact Us</span>
                    </MenuItem>
                    <MenuItem className='menuHeaderItemsContainer' onClick={() => logOut()}>
                        <ExitToApp />
                        <span>Logout</span>
                    </MenuItem>
                </Menu>

                <Menu
                    sx={{ mt: '45px' }}
                    id="admin-menu"
                    anchorEl={anchorElAdmin}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    keepMounted
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    open={Boolean(anchorElAdmin)}
                    onClose={handleCloseAdminMenu}
                >
                    <MenuItem className='menuHeaderItemsContainer' onClick={() => goToUsers("pending-requests")}>
                        <AccessTimeFilled />
                        <span>Pending Requests</span>
                    </MenuItem>
                    <MenuItem className='menuHeaderItemsContainer' onClick={() => goToUsers("approved-users")}>
                        <VerifiedUser />
                        <span>Approved Users</span>
                    </MenuItem>
                    <MenuItem className='menuHeaderItemsContainer' onClick={() => goToUsers("declined-users")}>
                        <DoDisturbOn />
                        <span>Declined Users</span>
                    </MenuItem>
                </Menu>
            </Toolbar>
        </AppBar>
    )
}

export default Header
